import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const CyclesService = {
  save: (
    name: string,
    comments: string,
    _id?: string,
    // account?: string,
    status?: boolean,
  ) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}cycles`, { _id, account, name, comments, status });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}cycles/${account}`);
  },
}